export default {
    english: 'English',
    simple_chinese: '简体中文',
};
